/*
* Copyright (C) 2019 SADE Innovations Oy - All Rights Reserved
*
* NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
* All dissemination, usage, modification, copying, reproduction, selling and distribution of the
* software and its intellectual and technical concepts are strictly forbidden without a valid license.
* Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
* (https://sadeinnovations.com).
*/

import { Dialog, Typography } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import React, { Component, ReactNode } from "react";
import CustomButton from "./custom-button";
import { translations } from "../../generated/translationHelper";

interface Props {
  errorMsg?: string;
  onClose: () => void;
  "data-testid"?: string;
}

export default class ErrorDialog extends Component<Props> {
  protected handleOk = (): void => {
    this.props.onClose();
  };

  public render(): ReactNode {
    if (!this.props.errorMsg) {
      return null;
    }
    return (
      <Dialog
        onClose={this.props.onClose}
        open={true}
      >
        <div className="popup-inner">
          <ErrorIcon color="error" style={{ verticalAlign: "sub" }}/>
          <Typography variant="h6" style={{ display: "inline-block" }}>
            {translations.common.texts.error()}
          </Typography>
          <div className="popup-body" data-testid={this.props["data-testid"]}>
            <p>{this.props.errorMsg}</p>
            <div className="buttons-container">
              <CustomButton
                variant="contained"
                color="secondary"
                onClick={this.handleOk}
                data-testid="err_popup_button"
              >
                {translations.common.buttons.ok()}
              </CustomButton>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}
